import React, { useEffect } from 'react';
import { Container } from '@material-ui/core';
import {
    FlexWrapper,
    Title,
    Description,
    StyledButton,
    StyledLink
} from './Success.styles';

export function Success() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    return (
        <Container>
            <FlexWrapper>
                <Title>Your message was successfully sent to our support team!</Title>
                <Description>We will contact you soon.</Description>
                <StyledButton to={`${process.env.REACT_APP_INTERNAL_URL}support`}>Send next message</StyledButton>
                <StyledLink to={`${process.env.REACT_APP_INTERNAL_URL}dashboard`}>Take me to dashboard</StyledLink>
            </FlexWrapper>
        </Container>
    )
}
